(function () {
  jQuery(document).on("click", '[data-behaviour~="copy-button"]', function () {
    // save the button width

    var element = jQuery(this);
    var width = element.outerWidth();
    var text = element.html();

    var copyValue = element.data("copy-value");
    var copyField = element.data("copy-field");
    var copyTarget = element.data("copy-target");

    var value;
    if (copyValue) {
      value = copyValue;
    } else if (copyField) {
      value = element.closest(".field").find(".field-input").val();
    } else if (copyTarget) {
      value = jQuery(copyTarget).val();
    } else {
      value = element.val();
    }

    navigator.clipboard.writeText(value);

    element.addClass("active");
    element.css({ "min-width": width, "text-align": "center" });
    element.html("Copied");

    setTimeout(function () {
      element.css({ "min-width": "", "text-align": "" });
      element.html(text);
      element.removeClass("active");
    }, 1000);
  });
})();
